export const importFileAdapter = (file, token, selectedInfo, form) => {
	return {
		file: file,
		token: token,
		interface: selectedInfo,
		headers: true,
		form: form,
	};
};
